import script from "./InputTextPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./InputTextPassword.vue?vue&type=script&setup=true&lang=js"

import "./InputTextPassword.vue?vue&type=style&index=0&id=5ea46635&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ea46635"]])

export default __exports__